import type { RootState } from '@/store/store';

export const selectAuth = (state: RootState) => state.auth;
export const selectCurrentAdmin = (state: RootState) => state.auth.userData;
export const selectAdminRole = (state: RootState) => state.auth.userData?.role;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
